// import React, { useState, useRef, useEffect } from "react";
// import { Link, useLocation, useSearchParams } from "react-router-dom";
// import ShareModal from "./Modal";
// import { Modal, Button, InputGroup, FormControl } from "react-bootstrap";
// import Test from "../../../Assets/img/banner ads.png";
// // import { HiMiniGift } from 'react-icons/hi';
// import { FaFacebookF, FaTwitter, FaLinkedinIn, FaWhatsapp, FaRegUser } from "react-icons/fa";
// import { HiMiniGift } from "react-icons/hi2";
// import ContentLocking from "./ContentLocking";
// import { BASE_URL, IMAGE_URL, security_key } from "../../../global";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import { toast } from "react-toastify";
// import ImageLoader from "../../Common/ImageLoader";
// import TextLoader from "../../Common/TextLoader";

// import DefaultAvatar from "./../../../Assets/img/avatar-default.jpeg";

// // import { KeyType } from "react-datepicker/dist/date_utils";
// // import Loader from "../../Pages/Home/Loader";

// const DemoModel = ({ show, handleClose }) => {
//     return (
//         <Modal show={show} onHide={handleClose} centered>
//             <Modal.Header closeButton></Modal.Header>
//             <Modal.Body className="text-center">
//                 <h3 className="fw-bold">Join Us & Earn Rewards!</h3>
//                 <p>New here? Share our articles with your network and start earning rewards instantly! Sign up now and benefits from every referral!</p>
//                 <div className="btn-grp d-flex justify-content-center align-items-center">
//                     <Link type="button" to="/login" className="btn btn-dark">
//                         <FaRegUser /> Login/Register
//                     </Link>
//                 </div>
//             </Modal.Body>
//         </Modal>
//     );
// };

// const SubModel = ({ show, handleClose }) => {
//     return (
//         <Modal show={show} onHide={handleClose} centered>
//             <Modal.Header closeButton></Modal.Header>
//             <Modal.Body className="text-center">
//                 <h3 className="fw-bold">Please Subscribe!</h3>
//                 <p>You are not subscribed to our service yet. To enjoy all the premium features and benefits, please choose a subscription plan.</p>
//                 <div className="btn-grp d-flex justify-content-center align-items-center">
//                     <Link type="button" to="/subscription" className="btn btn-dark">
//                         Subscribe
//                     </Link>
//                 </div>
//             </Modal.Body>
//         </Modal>
//     );
// };

// const Detail = ({ show }) => {
//     const elementRef = useRef(null);
//     const { id } = useParams();
//     const [loading, setLoading] = useState(false);
//     const [additionalFields, setAdditionalFields] = useState([]);
//     const [article, setArticle] = useState(null);
//     const [contentData, setContentnData] = useState("");
//     const [contentLink, setContentnLink] = useState(null);
//     const location = useLocation();
//     const [ads, setAds] = useState([]);
//     const [ac_summary, setAcSummary] = useState("");
//     const [isLoading, setIsLoading] = useState(false);

//     const fetchCalledRef = useRef(false);

//     useEffect(() => {
//         if (elementRef.current) {
//             elementRef.current.style.backgroundColor = "blue";
//         } else {
//             console.log("Element not found");
//         }
//     }, []);
//     const [showModal, setShowModal] = useState(false);

//     const [isLoggedIn, setIsLoggedIn] = useState(false);
//     const [isSubscribed, setSubscribed] = useState(false);
//     const [isRevealed, setIsRevealed] = useState(false);

//     useEffect(() => {
//         const loggedInStatus = sessionStorage.getItem("isLoggedIn");
//         const userType = sessionStorage.getItem("user_type");
//         const subscriptionStatus = sessionStorage.getItem("subscription_status");
//         setIsLoggedIn(loggedInStatus === "true");

//         if (userType === "1") {
//             setSubscribed(true); 
//         } else if (subscriptionStatus === "yes") {
//             setSubscribed(true);
//         } else {
//             setSubscribed(false);
//         }
//     }, [isLoggedIn, isSubscribed]);

//     const handleClose = () => setShowModal(false);
//     const handleShow = () => setShowModal(true);

//     const toggleReveal = () => {
//         if (isLoggedIn) {
//             setIsRevealed(!isRevealed);
//         }
//     };

//     useEffect(() => {
//         fetchArticle(id);
//     }, [id]);

//     const fetchArticle = async (id) => {
//         setIsLoading(true);
//         try {
//             const response = await axios.post(BASE_URL + "API/apicall", {
//                 security_key: security_key,
//                 pk_ac_key: id,
//                 mode: "getArticle",
//             });
//             const output = response.data;

//             const adsResponse = await fetchAds(output.cat_keys);
//             setAds(adsResponse);

//             if (output) {
//                 setAcSummary(output.ac_summary || "");
//                 setArticle(output);
//                 const parsedFields = JSON.parse(output.additionalFields);
//                 // const addArr = parsedFields.map((row) => ({
//                 //     pk_as_key: row.pk_as_key,
//                 //     fileType: row.file_type,
//                 //     type: row.content_type,
//                 //     value: row.content_type === "image/video" ? IMAGE_URL + row["file_name"] : row["as_content"],
//                 // }));

//                 setAdditionalFields(parsedFields);

//                 setContentnData("");

//                 // parsedFields.forEach((row, index) => {
//                 //     if (row.content_type === "multimedia" || row.content_type === "text" || row.content_type === "image/video") {
//                 //         var filterContent = row.as_content;
//                 //         if (row.content_type === "image/video" && row.base_type === "image") {
//                 //             filterContent = `<img className="img-fluid" src=${IMAGE_URL + row.as_content} />`;
//                 //         } else if (row.content_type === "image/video" && row.base_type === "video") {
//                 //             filterContent = `<video src=${IMAGE_URL + row.as_content} />`;
//                 //         }

//                 //         setContentnData((prevContentData) => prevContentData + filterContent);
//                 //     } else if (row.content_type === "iframe_link") {
//                 //         setContentnLink(row.as_content);
//                 //         // getFullArticle(row.as_content);
//                 //     }
//                 // });

//                 let accumulatedContentData = ""; // To accumulate content for state update
//                 let skipFirst = true; // Flag to skip the first image or video

//                 parsedFields.forEach((row) => {
//                     if (row.content_type === "multimedia" || row.content_type === "text" || row.content_type === "image/video") {
//                         let filterContent = row.as_content;

//                         // Skip the first image or video
//                         if (row.content_type === "image/video") {
//                             if (skipFirst) {
//                                 skipFirst = false; // Skip the first occurrence
//                                 return; // Move to the next iteration
//                             }

//                             if (row.base_type === "image") {
//                                 filterContent = `<div class="text-center">
//                                                     <img class="img-fluid" src="${IMAGE_URL + row.file_name}" alt="Image content"/>
//                                                 </div>`;
//                             } else if (row.base_type === "video") {
//                                 filterContent = `<div class="text-center">
//                                                     <video controls class="video-fluid" src="${IMAGE_URL + row.file_name}">
//                                                         Your browser does not support the video tag.
//                                                     </video>
//                                                 </div>`;
//                             }
//                         } else if (row.content_type === "multimedia") {
//                             filterContent = row.as_content.replace(/(<iframe[^>]*>.*?<\/iframe>)/, '<div class="ratio ratio-16x9">$1</div>');
//                             // filterContent = `<div class="ratio ratio-16x9">${row.as_content}</div>`;
//                             // filterContent = row.as_content;
//                         }

//                         accumulatedContentData += filterContent;
//                     } else if (row.content_type === "iframe_link") {
//                         setContentnLink(row.as_content);
//                     }
//                 });

//                 // Update the state after all rows are processed
//                 setContentnData((prevContentData) => prevContentData + accumulatedContentData);
//             }
//             setIsLoading(false)
//         } catch (error) {
//             toast.error("Error fetching article details." + error, {
//                 autoClose: 3000,
//             });
//         }
//         setLoading(false);
//     };

//     const viewStatus = JSON.parse(sessionStorage.getItem("view_status")) || [];

//     useEffect(() => {
//         if (!fetchCalledRef.current && !viewStatus.includes(id)) {
//             updateArticleViewCount();
//             addArticlViewerLog();
//             fetchCalledRef.current = true; // Mark as called
//         }
//     }, [id]);

//     const updateArticleViewCount = async () => {
//         try {
//             const response = await axios.post(BASE_URL + "API/apicall", {
//                 security_key: security_key,
//                 pk_ac_key: id,
//                 mode: "updateArticleViewCount",
//             });
//             const output = response.data;

//             if (output) {
//                 // Add the id to the viewStatus array
//                 viewStatus.push(id);
//                 sessionStorage.setItem("view_status", JSON.stringify(viewStatus)); // Store as a JSON string
//             }
//         } catch (error) {
//             toast.error("Error update article count.", { autoClose: 3000 });
//         }
//     };

//     const fetchAds = async (cat_keys) => {
//         try {

//             const parsedKeys = JSON.parse(cat_keys);
//             const cleanedKey = parsedKeys[0];

//             const response = await axios.post(BASE_URL + "API/apicall", {
//                 security_key: security_key,
//                 fk_cat_key: cleanedKey,
//                 mode: "showAd",
//             });
//             return response.data;
//         } catch (error) {
//             console.error("Error fetching ads:", error);
//             return [];
//         }
//     };

//     const ac_name = article ? article.ac_name : <TextLoader lineCount={1} width="100%" />;
//     // const ac_summary = article ? article.ac_summary : <TextLoader lineCount={15} width="100%" />;
//     const mod_publish_date = article ? article.mod_publish_date : ""; //15 April 2020
//     const author_info = article ? article.author_info : "[]";

//     // const imageData = additionalFields.find((item) => item.type === "image/video") || {};
//     // const detailImg = imageData.value || "default-image.jpg"; // Fallback image

//     // useEffect(() => {
//     //     console.log(imageData);
//     // }, [imageData]);

//     const getFullArticle = async (url) => {
//         const response = await axios.post(BASE_URL + "API/apicall", {
//             security_key: security_key,
//             mode: "getFullArticle",
//             url: url,
//         });

//         const output = response.data;

//         if (output) {
//             setContentnData(output);
//         }
//     };

//     const authorDetails = JSON.parse(author_info);
//     const author = authorDetails[0] || {}; // Get the first author
//     const { profile = "default-author.jpg", first_name = " ", last_name = <TextLoader lineCount={1} width="50%" /> } = author;

//     const authorImageUrl = authorDetails["profile_mod"] ? IMAGE_URL + profile : DefaultAvatar;
//     // const authorImageUrl = DefaultAvatar;

//     const [loadedImages, setLoadedImages] = useState({});
//     const [imageLoaded, setImageLoaded] = useState(false);
//     // Function to handle when an image is fully loaded
//     const handleImageLoad = (id) => {
//         setLoadedImages((prev) => ({ ...prev, [id]: true }));

//     };

//     const queryParams = new URLSearchParams(location.search);
//     const key = queryParams.get("key");

//     useEffect(() => {

//         const fetchUserIPAndUpdateArticle = async () => {
//             try {
//                 const ipResponse = await axios.get("https://api.ipify.org?format=json");
//                 const userIP = ipResponse.data.ip;

//                 // Now send the IP and article ID to the backend
//                 await axios.post(`${BASE_URL}API/apicall`, {
//                     security_key: security_key,
//                     fk_user_key: atob(key),
//                     fk_ac_key: id,
//                     mode: "addShareTrackData",
//                     device_ip: userIP,
//                 });

//             } catch (error) {
//                 console.error("Error fetching user IP or logging access:", error);
//             }
//         };

//         if (key) {
//             fetchUserIPAndUpdateArticle();
//             sessionStorage.setItem("referral_code", atob(key));
//         } else {
//             sessionStorage.setItem("referral_code", "");
//         }
//     }, [key]);

//     const addArticlViewerLog = async () => {
//         try {
//             const ipResponse = await axios.get("https://api.ipify.org?format=json");
//             const userIP = ipResponse.data.ip;

//             // Now send the IP and article ID to the backend
//             await axios.post(`${BASE_URL}API/apicall`, {
//                 security_key: security_key,
//                 fk_ac_key: id,
//                 mode: "addArticlViewerLog",
//                 device_ip: userIP,
//                 viewer_user_key: sessionStorage.getItem("pk_user_key") ? sessionStorage.getItem("pk_user_key") : null,
//             });
//         } catch (error) {
//             console.error("Error fetching user IP or logging access:", error);
//         }
//     };

//     return (
//         <>
//             {/* {loading && <Loader />} */}

//             <div>
//                 <main>
//                     <div className="container single-content">
//                         <div className="mb-20 mt-10 ">
//                             <h1 className="entry-title mb-30 font-weight-500">{ac_name}</h1>
//                             <div className="details-sec m-0">
//                                 <div className="row">
//                                     <div className="col-md-6 col-lg-6">
//                                         <div className="entry-meta align-items-center meta-2 font-small color-muted">
//                                             <p className="">
//                                                 <a className="author-avatar" href="#">
//                                                     {isLoading && <ImageLoader width={50} height={50} style={{ maxWidth: "100%" }} onLoadedData={handleImageLoad} />}
//                                                     <img
//                                                         className="img-circle"
//                                                         src={authorImageUrl}
//                                                         alt="author"
//                                                         style={{ display: imageLoaded ? "block" : "none" }}
//                                                         onLoad={() => setImageLoaded(false)}
//                                                     />
//                                                 </a>
//                                                 By{" "}
//                                                 <a href="#">
//                                                     <span className="author-name font-weight-bold">
//                                                         {first_name} {last_name}
//                                                     </span>
//                                                 </a>
//                                             </p>
//                                             <span className="mr-10">{mod_publish_date}</span>
//                                             {/* <span className="has-dot">8 mins read</span> */}
//                                         </div>
//                                     </div>
//                                     <div className="col-md-6 col-lg-6 text-right">
//                                         <div className="single-tools">
//                                             <Link className="btn btn-dark share-btn" onClick={handleShow}>
//                                                 <HiMiniGift className="f-20 me-2" />
//                                                 Share and Earn
//                                             </Link>
//                                         </div>
//                                     </div>
//                                     {isLoggedIn && isSubscribed ? (
//                                         <ShareModal show={showModal} handleClose={handleClose} />
//                                     ) : isLoggedIn ? (
//                                         <SubModel show={showModal} handleClose={handleClose} />
//                                     ) : (
//                                         <DemoModel show={showModal} handleClose={handleClose} />
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="row">
//                             <div className="col-lg-2 detail-wrapper-1 px-0">
//                                 <div className={`px-0 mb-3 entry-right-col`}>
//                                     {ads.length > 0 && ads[0].adv_img_mod ? (
//                                         <>
//                                             <img
//                                                 src={IMAGE_URL + ads[0].adv_img_mod}
//                                                 className="img-fluid"
//                                                 alt=""
//                                                 // style={{ height: '550px' }}
//                                             />
//                                             {/* <h5>{ads[0].adv_title}</h5> */}
//                                             {/* <p>{ads[0].adv_description}</p> */}
//                                         </>
//                                     ) : (
//                                         <img src={Test} className="img-fluid" alt="" />
//                                     )}
//                                 </div>
//                             </div>

//                             <div className="col-md-12 col-lg-8">
//                                 <figure className="image mb-30 m-auto border-radius-2  d-flex justify-content-center align-items-center">
//                                     <div className="row justify-content-center align-items-start">
//                                         <div className="col-md-12 col-lg-12">
//                                         {isLoading && <ImageLoader width={900} height={450} />}
//                                             {additionalFields
//                                                 .filter((row) => row.content_type == "image/video")
//                                                 .map((row, index) => {
//                                                     if (index == 0) {
//                                                         if (row.base_type === "image") {
//                                                             return (
//                                                                 <img
//                                                                     key={index}
//                                                                     src={IMAGE_URL + row.file_name}
//                                                                     className="detail-banner"
//                                                                     width={"100%"}
//                                                                     alt="post-title"
//                                                                     style={{
//                                                                         display: imageLoaded ? "block" : "none", minHeight:"450px", objectFit:"unset"
//                                                                     }} // Hide until image is loaded
//                                                                     onLoad={() => setImageLoaded(true)} // Set imageLoaded to true when the image is loaded
//                                                                 />
//                                                             );
//                                                         } else if (row.base_type === "video") {
//                                                             return (
//                                                                 <video
//                                                                     key={index}
//                                                                     src={IMAGE_URL + row.file_name}
//                                                                     className="detail-banner"
//                                                                     width={"100%"}
//                                                                     controls // Add controls for video
//                                                                     style={{
//                                                                         display: imageLoaded ? "block" : "none",
//                                                                     }} // Hide until video is loaded
//                                                                     onLoad={() => setImageLoaded(true)} // Set imageLoaded to true when the video is loaded
//                                                                 />
//                                                             );
//                                                         } else {
//                                                             return <div key={index}>Unsupported content type.</div>;
//                                                         }
//                                                     }
//                                                 })}
//                                         </div>
//                                     </div>
//                                 </figure>

//                                 <article className="entry-wraper mb-50">
//                                     <div className="row">
//                                         <div className="col-md-12 col-lg-12">
//                                             {/* <div className="excerpt mb-15"> */}
//                                             {isLoggedIn ? (
//                                                 <p>{ac_summary}</p> // Display full summary for logged-in users
//                                             ) : (
//                                                 <p>{ac_summary.substring(0, 200) + "..."}</p> // Display truncated summary for non-logged-in users
//                                             )}
//                                             {/* </div> */}
//                                             <div
//                                                 className={`entry-left-col ${
//                                                     {
//                                                         /*  */
//                                                     }
//                                                 }`}
//                                             >
//                                                 <div className="social-sticky">
//                                                     <a
//                                                         href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
//                                                             BASE_URL
//                                                         )}&t=${encodeURIComponent(ac_name)}`}
//                                                         target="_blank"
//                                                     >
//                                                         <i className="ti-facebook"></i>
//                                                     </a>
//                                                     <a
//                                                         href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(BASE_URL)}&t=${encodeURIComponent(
//                                                             ac_name
//                                                         )}`}
//                                                         target="_blank"
//                                                     >
//                                                         <i className="ti-twitter"></i>
//                                                     </a>
//                                                     <a
//                                                         href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
//                                                             BASE_URL
//                                                         )}&t=${encodeURIComponent(ac_name)}`}
//                                                         target="_blank"
//                                                     >
//                                                         <i className="ti-linkedin"></i>
//                                                     </a>
//                                                     <a
//                                                         href={`mailto:?subject=${encodeURIComponent("Check this out!")}&body=${encodeURIComponent(
//                                                             "I found this interesting article: " + BASE_URL
//                                                         )}`}
//                                                         target="_blank"
//                                                         rel="noopener noreferrer"
//                                                     >
//                                                         <i className="ti-email"></i>
//                                                     </a>
//                                                 </div>
//                                             </div>
//                                             <p>
//                                                 <div className="entry-main-content dropcap wow fadeIn animated">
//                                                     {/* <iframe
//                                                         src="https://www.nytimes.com/2024/09/24/world/middleeast/lebanon-damage-israel-airstrikes.html"
//                                                         frameborder="0"
//                                                         width="100%"
//                                                         height="700"
//                                                         sandbox="allow-scripts"
//                                                     ></iframe> */}

//                                                     {contentLink ? (
//                                                         <>
//                                                             {contentLink.includes("youtube.com") || contentLink.includes("youtu.be") ? (
//                                                                 <div className="embed-responsive embed-responsive-16by9">
//                                                                     <iframe
//                                                                         className="custom-iframe"
//                                                                         src={contentLink}
//                                                                         frameBorder="0"
//                                                                         style={{
//                                                                             width: "100%",
//                                                                             border: "none",
//                                                                         }}
//                                                                         allowFullScreen
//                                                                     ></iframe>
//                                                                 </div>
//                                                             ) : (
//                                                                 <div className="embed-responsive embed-responsive-16by9">
//                                                                     <iframe
//                                                                         className="custom-iframe"
//                                                                         src={`https://capdigi.tech/2024/paperboy/API/article_iframe.php?url=${contentLink}`}
//                                                                         frameBorder="0"
//                                                                         style={{
//                                                                             width: "100%",
//                                                                             height: "100vh",
//                                                                             border: "none",
//                                                                         }}
//                                                                         allowFullScreen
//                                                                     ></iframe>
//                                                                 </div>
//                                                             )}
//                                                         </>
//                                                     ) : (
//                                                         <p className="mb-0">
//                                                             <div
//                                                                 dangerouslySetInnerHTML={{
//                                                                     __html: contentData,
//                                                                 }}
//                                                             />
//                                                         </p>
//                                                     )}

//                                                     <hr className="wp-block-separator is-style-dots m-0" />

//                                                     <div className={`content ${isLoggedIn && isSubscribed ? "unlocked" : "locked"}`}>
//                                                         <div className={`  dropcap wow fadeIn animated ${isLoggedIn && isSubscribed ? "d-block" : "d-none"}`}>
//                                                             <ContentLocking id={id} />
//                                                         </div>
//                                                         {!isLoggedIn ? (
//                                                             <div className="read-more">
//                                                                 <div className="box-shade"></div>
//                                                                 <Link to="/login" className="btn btn-dark">
//                                                                     Login to Read More
//                                                                 </Link>
//                                                             </div>
//                                                         ) : !isSubscribed ? (
//                                                             <div className="read-more">
//                                                                 <div className="box-shade"></div>
//                                                                 <Link to="/subscription" className="btn btn-dark">
//                                                                     Subscribe
//                                                                 </Link>
//                                                             </div>
//                                                         ) : (
//                                                             <></>
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                             </p>
//                                         </div>
//                                     </div>
//                                 </article>
//                             </div>

//                             <div className="col-md-12 col-lg-2 detail-wrapper-2 px-0">
//                                 <>
//                                     {ads.length > 1 ? (
//                                         <>
//                                             {ads.slice(1).map((ad, index) => (
//                                                 <div className={`px-0 mb-3 entry-right-col`} key={index}>
//                                                     {ad.adv_img_mod ? (
//                                                         <>
//                                                             <img
//                                                                 src={IMAGE_URL + ad.adv_img_mod}
//                                                                 className="img-fluid"
//                                                                 alt=""
//                                                                 // style={{ height: '550px' }}
//                                                             />
//                                                             {/* <h5>{ad.adv_title}</h5> */}
//                                                             {/* <p>{ad.adv_description}</p> */}
//                                                         </>
//                                                     ) : (
//                                                         <img src={Test} className="img-fluid" alt="" />
//                                                     )}
//                                                 </div>
//                                             ))}
//                                         </>
//                                     ) : (
//                                         <img src={Test} className="img-fluid" alt="" />
//                                     )}
//                                 </>
//                             </div>
//                         </div>
//                     </div>
//                 </main>
//                 <style jsx>
//                     {`
//                         .content-container {
//                             position: relative;
//                             width: 100%;
//                             max-width: 800px;
//                             margin: 0 auto;
//                         }

//                         .content {
//                             position: relative;
//                             padding: 20px;
//                             background: #fff;
//                         }

//                         .content.locked {
//                             position: relative;
//                         }

//                         .read-more {
//                             position: absolute;
//                             top: -10px;
//                             left: 0;
//                             width: 100%;
//                             height: 100%;
//                             background: linear-gradient(hsla(0, 0%, 100%, 1), #fff);
//                             display: flex;
//                             flex-direction: column;
//                             // justify-content: center;
//                             align-items: center;
//                             z-index: 1;
//                         }

//                         .read-more button {
//                             padding: 10px 20px;
//                             font-size: 16px;
//                             cursor: pointer;
//                         }

//                         .content.unlocked .read-more {
//                             display: none;
//                         }
//                         .box-shade {
//                             margin-top: -240px;
//                             height: 250px;
//                             background: linear-gradient(rgba(255, 255, 255, 0), rgb(255, 255, 255));
//                             width: 100%;
//                         }

//                         /* Container for the iframe */
//                         .iframe-container {
//                             width: 100%;
//                             height: 100vh;
//                             overflow: hidden; /* Hide scrollbars for the container */
//                         }

//                         /* Hide scrollbars within the iframe */
//                         .custom-iframe {
//                             width: 100%;
//                             height: 100vh;
//                             border: none;
//                             overflow: hidden; /* Hide scrollbars within the iframe */
//                             display: block; /* Ensure iframe is block-level to prevent inline spacing issues */
//                         }

//                         /* Hide scrollbars for specific browsers */
//                         .custom-iframe::-webkit-scrollbar {
//                             display: none; /* Hide scrollbar in Chrome, Safari, and Edge */
//                         }

//                         .custom-iframe {
//                             -ms-overflow-style: none; /* Hide scrollbar in Internet Explorer and Edge */
//                             scrollbar-width: none; /* Hide scrollbar in Firefox */
//                         }
//                     `}
//                 </style>
//             </div>
//         </>
//     );
// };

// export default Detail;



import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import ShareModal from "./Modal";
import { Modal, Button, InputGroup, FormControl } from "react-bootstrap";
import Test from "../../../Assets/img/banner ads.png";
// import { HiMiniGift } from 'react-icons/hi';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaWhatsapp, FaRegUser } from "react-icons/fa";
import { HiMiniGift } from "react-icons/hi2";
import ContentLocking from "./ContentLocking";
import { BASE_URL, IMAGE_URL, security_key } from "../../../global";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import ImageLoader from "../../Common/ImageLoader";
import TextLoader from "../../Common/TextLoader";

import DefaultAvatar from "./../../../Assets/img/avatar-default.jpeg";
import LinearProgress from "@mui/material/LinearProgress";


// import { KeyType } from "react-datepicker/dist/date_utils";
// import Loader from "../../Pages/Home/Loader";

const DemoModel = ({ show, handleClose }) => {
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body className="text-center">
                <h3 className="fw-bold">Join Us & Earn Rewards!</h3>
                <p>New here? Share our articles with your network and start earning rewards instantly! Sign up now and benefits from every referral!</p>
                <div className="btn-grp d-flex justify-content-center align-items-center">
                    <Link type="button" to="/login" className="btn btn-dark">
                        <FaRegUser /> Login/Register
                    </Link>
                </div>
            </Modal.Body>
        </Modal>
    );
};

const SubModel = ({ show, handleClose }) => {
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body className="text-center">
                <h3 className="fw-bold">Please Subscribe!</h3>
                <p>You are not subscribed to our service yet. To enjoy all the premium features and benefits, please choose a subscription plan.</p>
                <div className="btn-grp d-flex justify-content-center align-items-center">
                    <Link type="button" to="/subscription" className="btn btn-dark">
                        Subscribe
                    </Link>
                </div>
            </Modal.Body>
        </Modal>
    );
};

const Detail = ({ show }) => {
    const elementRef = useRef(null);
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [additionalFields, setAdditionalFields] = useState([]);
    const [article, setArticle] = useState(null);
    const [contentData, setContentnData] = useState("");
    const [contentLink, setContentnLink] = useState(null);
    const location = useLocation();
    const [ads, setAds] = useState([]);
    const [ac_summary, setAcSummary] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [members, setMembers] = useState([]);
    const [link, setLink] = useState(window.location.href);
    const [statusMessage, setStatusMessage] = useState("");
    const [statusClass, setStatusClass] = useState("");


    const fetchCalledRef = useRef(false);
    const CatKey = location.state?.catKey;
    console.log('CatKey',CatKey)

    useEffect(() => {
        if (elementRef.current) {
            elementRef.current.style.backgroundColor = "blue";
        } else {
            console.log("Element not found");
        }
    }, []);
    const [showModal, setShowModal] = useState(false);

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isSubscribed, setSubscribed] = useState(false);
    const [isRevealed, setIsRevealed] = useState(false);

    useEffect(() => {
        const loggedInStatus = sessionStorage.getItem("isLoggedIn");
        const userType = sessionStorage.getItem("user_type");
        const subscriptionStatus = sessionStorage.getItem("subscription_status");
        setIsLoggedIn(loggedInStatus === "true");

        if (userType === "1") {
            setSubscribed(true);
        } else if (subscriptionStatus === "yes") {
            setSubscribed(true);
        } else {
            setSubscribed(false);
        }
    }, [isLoggedIn, isSubscribed]);

    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    const toggleReveal = () => {
        if (isLoggedIn) {
            setIsRevealed(!isRevealed);
        }
    };

    useEffect(() => {
        fetchArticle(id);
    }, [id]);

    const fetchArticle = async (id) => {
        setIsLoading(true);
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                pk_ac_key: id,
                mode: "getArticle",
            });
            const output = response.data;

            console.log('catkeyoutput', output)

            const adsResponse = await fetchAds(output.cat_keys);
            setAds(adsResponse);

            if (output) {
                setAcSummary(output.ac_summary || "");
                setArticle(output);
                const parsedFields = JSON.parse(output.additionalFields);


                setAdditionalFields(parsedFields);

                setContentnData("");


                let accumulatedContentData = ""; // To accumulate content for state update
                let skipFirst = true; // Flag to skip the first image or video

                parsedFields.forEach((row) => {
                    if (row.content_type === "multimedia" || row.content_type === "text" || row.content_type === "image/video") {
                        let filterContent = row.as_content;

                        // Skip the first image or video
                        if (row.content_type === "image/video") {
                            if (skipFirst) {
                                skipFirst = false; // Skip the first occurrence
                                return; // Move to the next iteration
                            }

                            if (row.base_type === "image") {
                                filterContent = `<div class="text-center">
                                                    <img class="img-fluid" src="${IMAGE_URL + row.file_name}" alt="Image content"/>
                                                </div>`;
                            } else if (row.base_type === "video") {
                                filterContent = `<div class="text-center">
                                                    <video controls class="video-fluid" src="${IMAGE_URL + row.file_name}">
                                                        Your browser does not support the video tag.
                                                    </video>
                                                </div>`;
                            }
                        } else if (row.content_type === "multimedia") {
                            filterContent = row.as_content.replace(/(<iframe[^>]*>.*?<\/iframe>)/, '<div class="ratio ratio-16x9">$1</div>');
                            // filterContent = `<div class="ratio ratio-16x9">${row.as_content}</div>`;
                            // filterContent = row.as_content;
                        }

                        accumulatedContentData += filterContent;
                    } else if (row.content_type === "iframe_link") {
                        setContentnLink(row.as_content);
                    }
                });

                // Update the state after all rows are processed
                setContentnData((prevContentData) => prevContentData + accumulatedContentData);
            }
            setIsLoading(false)
        } catch (error) {
            toast.error("Error fetching article details." + error, {
                autoClose: 3000,
            });
        }
        setLoading(false);
    };

    const viewStatus = JSON.parse(sessionStorage.getItem("view_status")) || [];

    useEffect(() => {
        if (!fetchCalledRef.current && !viewStatus.includes(id)) {
            updateArticleViewCount();
            addArticlViewerLog();
            fetchCalledRef.current = true; // Mark as called
        }
    }, [id]);

    const updateArticleViewCount = async () => {
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                pk_ac_key: id,
                mode: "updateArticleViewCount",
            });
            const output = response.data;

            if (output) {
                // Add the id to the viewStatus array
                viewStatus.push(id);
                sessionStorage.setItem("view_status", JSON.stringify(viewStatus)); // Store as a JSON string
            }
        } catch (error) {
            toast.error("Error update article count.", { autoClose: 3000 });
        }
    };

    useEffect(() => {
        fetchAllUser();
    }, []);

    const fetchAllUser = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllMembersData",
        });

        const output = response.data;

        if (output.length > 0) {
            setMembers(output);
        }
    };



    const handleShareAllTopline = async () => {
        const toplineMembers = members.filter((member) => Number(member.user_level) === 7);

        if (toplineMembers.length === 0) {
            toast.info("No topline members found.", { autoClose: 3000 });
            setShowConfirmModal(false);
            return;
        }

        try {
            setIsSubmitting(true);

            const promises = toplineMembers.map((member) =>
                axios.post(`${BASE_URL}API/apicall`, {
                    user_key: member.pk_user_key,
                    ac_link: link,
                    security_key: security_key,
                    mode: "shareAcNotification",
                    created_by: sessionStorage.getItem("pk_user_key"),
                })
            );

            const responses = await Promise.all(promises);
            const allSuccess = responses.every((res) => res.data === 1);

            if (allSuccess) {
                toast.success("Article shared successfully to all topline members.", { autoClose: 3000 });
                setStatusMessage("Shared successfully with all topline members.");
                setStatusClass("bg-success text-light");
            } else {
                toast.error("Some notifications failed to send.", { autoClose: 3000 });
                setStatusMessage("Some topline notifications failed to send.");
                setStatusClass("bg-danger text-light");
            }
        } catch (error) {
            console.error("Error sharing with topline members:", error);
            toast.error("Error occurred while sharing with topline members.", { autoClose: 3000 });
            setStatusMessage("Error occurred while sharing with topline members.");
            setStatusClass("bg-danger text-light");
        } finally {
            setIsSubmitting(false);
            setShowConfirmModal(false); // close modal
            setTimeout(() => {
                setStatusMessage("");
                setStatusClass("");
            }, 3000);
        }
    };

    // const fetchAds = async (cat_keys) => {
    //     try {

    //         const parsedKeys = JSON.parse(cat_keys);
    //         const cleanedKey = parsedKeys[0];

    //         const response = await axios.post(BASE_URL + "API/apicall", {
    //             security_key: security_key,
    //             fk_cat_key: 'AFDD8FE269FBEC65',
    //             mode: "showAd",
    //         });
    //         return response.data;
    //     } catch (error) {
    //         console.error("Error fetching ads:", error);
    //         return [];
    //     }
    // };

    const fetchAds = async (cat_keys) => {
        try {
            const parsedKeys = JSON.parse(cat_keys);
            const allAds = [];

            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                fk_cat_key: CatKey,
                mode: "showAd",
            });

            if (Array.isArray(response.data)) {
                allAds.push(...response.data);
            }

            // Remove duplicates (based on pk_adv_key)
            const uniqueAds = allAds.filter(
                (ad, index, self) => index === self.findIndex((a) => a.pk_adv_key === ad.pk_adv_key)
            );

            const groupedAds = {
                top: uniqueAds.filter(ad => ad.adposition?.toLowerCase() === "top"),
                left: uniqueAds.filter(ad => ad.adposition?.toLowerCase() === "left"),
                right: uniqueAds.filter(ad => ad.adposition?.toLowerCase() === "right"),
                bottom: uniqueAds.filter(ad => ad.adposition?.toLowerCase() === "bottom"),
                none: uniqueAds.filter(ad => !ad.adposition)
            };

            return groupedAds;

        } catch (error) {
            console.error("Error fetching ads:", error);
            return {
                top: [],
                left: [],
                right: [],
                bottom: [],
                none: []
            };
        }
    };



    const ac_name = article ? article.ac_name : <TextLoader lineCount={1} width="100%" />;
    // const ac_summary = article ? article.ac_summary : <TextLoader lineCount={15} width="100%" />;
    const mod_publish_date = article ? article.mod_publish_date : ""; //15 April 2020
    const author_info = article ? article.author_info : "[]";

    // const imageData = additionalFields.find((item) => item.type === "image/video") || {};
    // const detailImg = imageData.value || "default-image.jpg"; // Fallback image

    // useEffect(() => {
    //     console.log(imageData);
    // }, [imageData]);

    const getFullArticle = async (url) => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getFullArticle",
            url: url,
        });

        const output = response.data;

        if (output) {
            setContentnData(output);
        }
    };

    const authorDetails = JSON.parse(author_info);
    const author = authorDetails[0] || {}; // Get the first author
    const { profile = "default-author.jpg", first_name = " ", last_name = <TextLoader lineCount={1} width="50%" /> } = author;

    const authorImageUrl = authorDetails["profile_mod"] ? IMAGE_URL + profile : DefaultAvatar;
    // const authorImageUrl = DefaultAvatar;

    const [loadedImages, setLoadedImages] = useState({});
    const [imageLoaded, setImageLoaded] = useState(false);
    // Function to handle when an image is fully loaded
    const handleImageLoad = (id) => {
        setLoadedImages((prev) => ({ ...prev, [id]: true }));

    };

    const queryParams = new URLSearchParams(location.search);
    const key = queryParams.get("key");

    useEffect(() => {

        const fetchUserIPAndUpdateArticle = async () => {
            try {
                const ipResponse = await axios.get("https://api.ipify.org?format=json");
                const userIP = ipResponse.data.ip;

                // Now send the IP and article ID to the backend
                await axios.post(`${BASE_URL}API/apicall`, {
                    security_key: security_key,
                    fk_user_key: atob(key),
                    fk_ac_key: id,
                    mode: "addShareTrackData",
                    device_ip: userIP,
                });

            } catch (error) {
                console.error("Error fetching user IP or logging access:", error);
            }
        };

        if (key) {
            fetchUserIPAndUpdateArticle();
            sessionStorage.setItem("referral_code", atob(key));
        } else {
            sessionStorage.setItem("referral_code", "");
        }
    }, [key]);

    const addArticlViewerLog = async () => {
        try {
            const ipResponse = await axios.get("https://api.ipify.org?format=json");
            const userIP = ipResponse.data.ip;

            await axios.post(`${BASE_URL}API/apicall`, {
                security_key: security_key,
                fk_ac_key: id,
                mode: "addArticlViewerLog",
                device_ip: userIP,
                viewer_user_key: sessionStorage.getItem("pk_user_key") ? sessionStorage.getItem("pk_user_key") : null,
            });
        } catch (error) {
            console.error("Error fetching user IP or logging access:", error);
        }
    };

    return (
        <>
            <div>
                <main>
                    <div className="container single-content">

                        {ads.top?.length > 0 && (
                            <div className="row justify-content-center mb-3">
                                {ads.top.map((ad, index) => (
                                    <div key={index} className="col-12 text-center mb-3">
                                        <a href={ad.adv_url || "#"} target="_blank" rel="noopener noreferrer">
                                            <img
                                                src={IMAGE_URL + ad.adv_img_mod}
                                                alt={ad.adv_title}
                                                className="img-fluid"
                                                style={{ maxHeight: "200px", objectFit: "contain" }}
                                            />
                                        </a>
                                    </div>
                                ))}
                            </div>
                        )}

                        <div className="mb-20 mt-10 ">
                            <h1 className="entry-title mb-30 font-weight-500">{ac_name}</h1>
                            <div className="details-sec m-0">
                                <div className="row">
                                    <div className="col-md-6 col-lg-6">
                                        <div className="entry-meta align-items-center meta-2 font-small color-muted">
                                            <p className="">
                                                <a className="author-avatar" href="#">
                                                    {isLoading && (
                                                        <ImageLoader
                                                            width={50}
                                                            height={50}
                                                            style={{ maxWidth: "100%" }}
                                                            onLoadedData={handleImageLoad}
                                                        />
                                                    )}
                                                    <img
                                                        className="img-circle"
                                                        src={authorImageUrl}
                                                        alt="author"
                                                        style={{ display: imageLoaded ? "block" : "none" }}
                                                        onLoad={() => setImageLoaded(false)}
                                                    />
                                                </a>
                                                By{" "}
                                                <a href="#">
                                                    <span className="author-name font-weight-bold">
                                                        {first_name} {last_name}
                                                    </span>
                                                </a>
                                            </p>
                                            <span className="mr-10">{mod_publish_date}</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-lg-6 text-right">
                                        <div className="single-tools">
                                            <Link className="btn btn-dark share-btn" onClick={handleShow}>
                                                <HiMiniGift className="f-20 me-2" />
                                                Share and Earn
                                            </Link>
                                        </div>
                                    </div>
                                    {isLoggedIn && isSubscribed ? (
                                        <ShareModal show={showModal} handleClose={handleClose} />
                                    ) : isLoggedIn ? (
                                        <SubModel show={showModal} handleClose={handleClose} />
                                    ) : (
                                        <DemoModel show={showModal} handleClose={handleClose} />
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            {ads.left?.length > 0 && (
                                <div className="col-lg-2 detail-wrapper-1 px-0">
                                    {ads.left.map((ad, index) => (
                                        <div className="px-0 mb-3 entry-right-col" key={index}>
                                            <a href={ad.adv_url || "#"} target="_blank" rel="noopener noreferrer">
                                                <img
                                                    src={IMAGE_URL + ad.adv_img_mod}
                                                    className="img-fluid"
                                                    alt={ad.adv_title}
                                                />
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            )}

                            <div
                                className={`col-md-12 col-lg-${ads.left?.length > 0 && ads.right?.length > 0
                                    ? "8"
                                    : ads.left?.length > 0 || ads.right?.length > 0
                                        ? "10"
                                        : "12"
                                    }`}
                            >
                                <figure className="image mb-30 m-auto border-radius-2 d-flex justify-content-center align-items-center">
                                    <div className="row justify-content-center align-items-start">
                                        <div className="col-md-12 col-lg-12">
                                            {isLoading && <ImageLoader width={900} height={450} />}
                                            {additionalFields
                                                .filter(row => row.content_type == "image/video")
                                                .map((row, index) => {
                                                    if (index == 0) {
                                                        if (row.base_type === "image") {
                                                            return (
                                                                <img
                                                                    key={index}
                                                                    src={IMAGE_URL + row.file_name}
                                                                    className="detail-banner"
                                                                    width={"100%"}
                                                                    alt="post-title"
                                                                    style={{
                                                                        display: imageLoaded ? "block" : "none",
                                                                        minHeight: "450px",
                                                                        objectFit: "unset",
                                                                    }}
                                                                    onLoad={() => setImageLoaded(true)}
                                                                />
                                                            );
                                                        } else if (row.base_type === "video") {
                                                            return (
                                                                <video
                                                                    key={index}
                                                                    src={IMAGE_URL + row.file_name}
                                                                    className="detail-banner"
                                                                    width={"100%"}
                                                                    controls
                                                                    style={{ display: imageLoaded ? "block" : "none" }}
                                                                    onLoad={() => setImageLoaded(true)}
                                                                />
                                                            );
                                                        } else {
                                                            return <div key={index}>Unsupported content type.</div>;
                                                        }
                                                    }
                                                })}
                                        </div>
                                    </div>
                                </figure>

                                <article className="entry-wraper mb-50">
                                    <div className="row">
                                        <div className="col-md-12 col-lg-12">
                                            {isLoggedIn ? (
                                                <p>{ac_summary}</p>
                                            ) : (
                                                <p>{ac_summary.substring(0, 200) + "..."}</p>
                                            )}
                                            <div className="entry-left-col">
                                                <div className="social-sticky">
                                                    <a
                                                        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                                                            BASE_URL
                                                        )}&t=${encodeURIComponent(ac_name)}`}
                                                        target="_blank"
                                                    >
                                                        <i className="ti-facebook"></i>
                                                    </a>
                                                    <a
                                                        href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                                                            BASE_URL
                                                        )}&t=${encodeURIComponent(ac_name)}`}
                                                        target="_blank"
                                                    >
                                                        <i className="ti-twitter"></i>
                                                    </a>
                                                    <a
                                                        href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
                                                            BASE_URL
                                                        )}&t=${encodeURIComponent(ac_name)}`}
                                                        target="_blank"
                                                    >
                                                        <i className="ti-linkedin"></i>
                                                    </a>
                                                    <a
                                                        href={`mailto:?subject=${encodeURIComponent(
                                                            "Check this out!"
                                                        )}&body=${encodeURIComponent(
                                                            "I found this interesting article: " + BASE_URL
                                                        )}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <i className="ti-email"></i>
                                                    </a>
                                                </div>
                                            </div>

                                            <div className="entry-main-content dropcap wow fadeIn animated">
                                                {contentLink ? (
                                                    <>
                                                        {contentLink.includes("youtube.com") ||
                                                            contentLink.includes("youtu.be") ? (
                                                            <div className="embed-responsive embed-responsive-16by9">
                                                                <iframe
                                                                    className="custom-iframe"
                                                                    src={contentLink}
                                                                    frameBorder="0"
                                                                    style={{
                                                                        width: "100%",
                                                                        border: "none",
                                                                    }}
                                                                    allowFullScreen
                                                                ></iframe>
                                                            </div>
                                                        ) : (
                                                            <div className="embed-responsive embed-responsive-16by9">
                                                                <iframe
                                                                    className="custom-iframe"
                                                                    src={`https://thepaperboy.net/API/article_iframe.php?url=${contentLink}`}
                                                                    frameBorder="0"
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "100vh",
                                                                        border: "none",
                                                                    }}
                                                                    allowFullScreen
                                                                ></iframe>
                                                            </div>
                                                        )}
                                                    </>
                                                ) : (
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: contentData,
                                                        }}
                                                    />
                                                )}

                                                <hr className="wp-block-separator is-style-dots m-0" />


                                                <div
                                                    className={`content ${isLoggedIn && isSubscribed ? "unlocked" : "locked"
                                                        }`}
                                                >

                                                    <div
                                                        className={`dropcap wow fadeIn animated ${isLoggedIn && isSubscribed ? "d-block" : "d-none"
                                                            }`}
                                                    >
                                                        <div className="mt-3">
                                                            <Button
                                                                variant="dark"
                                                                onClick={() => setShowConfirmModal(true)}
                                                                disabled={isSubmitting}
                                                            >
                                                                Share with All Topline Members
                                                                {isSubmitting && <LinearProgress />}
                                                            </Button>
                                                        </div>
                                                        <ContentLocking id={id} />
                                                    </div>

                                                    {!isLoggedIn ? (
                                                        <div className="read-more">
                                                            <div className="box-shade"></div>
                                                            <Link to="/login" className="btn btn-dark">
                                                                {/* Login to Read More */}
                                                                Click to Share
                                                            </Link>
                                                        </div>
                                                    ) : !isSubscribed ? (
                                                        <div className="read-more">
                                                            <div className="box-shade"></div>
                                                            <Link to="/subscription" className="btn btn-dark">
                                                                Subscribe
                                                            </Link>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </article>
                            </div>

                            {ads.right?.length > 0 && (
                                <div className="col-md-12 col-lg-2 detail-wrapper-2 px-0">
                                    {ads.right.map((ad, index) => (
                                        <div className="px-0 mb-3 entry-right-col" key={index}>
                                            <a href={ad.adv_url || "#"} target="_blank" rel="noopener noreferrer">
                                                <img
                                                    src={IMAGE_URL + ad.adv_img_mod}
                                                    className="img-fluid"
                                                    alt={ad.adv_title}
                                                />
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        {ads.bottom?.length > 0 && (
                            <div className="row justify-content-center mt-3">
                                {ads.bottom.map((ad, index) => (
                                    <div key={index} className="col-12 text-center mb-3">
                                        <a href={ad.adv_url || "#"} target="_blank" rel="noopener noreferrer">
                                            <img
                                                src={IMAGE_URL + ad.adv_img_mod}
                                                alt={ad.adv_title}
                                                className="img-fluid"
                                                style={{ maxHeight: "200px", objectFit: "contain" }}
                                            />
                                        </a>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </main>

                <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Share</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        <p>Are you sure you want to share this article with all Topline Members?</p>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-center">
                        <Button variant="outline-dark" onClick={() => setShowConfirmModal(false)}>
                            No
                        </Button>
                        <Button variant="dark" onClick={handleShareAllTopline} disabled={isSubmitting}>
                            Yes, Share
                            {isSubmitting && <LinearProgress />}
                        </Button>
                    </Modal.Footer>
                </Modal>

                <style jsx>{`
                .box-shade {
                    margin-top: -240px;
                    height: 250px;
                    background: linear-gradient(rgba(255, 255, 255, 0), rgb(255, 255, 255));
                    width: 100%;
                }
            `}</style>
            </div>
        </>
    );


};

export default Detail;
